import React from "react";
import ReactDOM from "react-dom";
import "./App.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as AWS from 'aws-sdk'

const configuration = {
  region: 'us-east-1',
  secretAccessKey: 'pbB5rUOe7+2ECT1fiDMQYp0DA0PJWPRFtejv92Ag',
  accessKeyId: 'AKIAWENPZQUFICV7X77K'
}

AWS.config.update(configuration)

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
